import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// label ของหัวกลุ่มประกาศ map ตาม supportTypeId (เพื่อให้คอลัมน์ตรงกับข้อมูลที่ backend ส่งมาเสมอ)
const TYPE_LABEL_MAP = {
    1: "ผู้ดำเนินการทดสอบฯ มีผู้ผ่านการทดสอบในปีที่ผ่านมา ตั้งแต่ 100 คนขึ้นไป (ประกาศข้อ 4)",
    4: "ผู้ประกอบกิจการที่ดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้างตามมาตรา 29 วรรคสอง (ประกาศข้อ 5)",
    5: "ประกอบกิจการที่ส่งเงินสมทบเข้ากองทุนฯ และได้ดำเนินการพัฒนาฝีมือแรงงานฯ (ประกาศข้อ 6)",
    6: "ผู้ประกอบกิจการที่ได้รับรองมาตรฐานฝีมือแรงงานฯ ได้นำมาตรฐานฝีมือแรงงานดังกล่าวไปใช้ในการทดสอบฯ (ประกาศข้อ 7)",
    7: "ผู้ประกอบกิจการที่ส่งลูกจ้างเข้ารับการทดสอบฯ และได้จ่ายค่าจ้างให้แก่ลูกจ้าง (ประกาศข้อ 8)",
    8: "พัฒนาทักษะความรู้ให้แก่ลูกจ้างเพื่อเป็นการสร้างสรรค์ นวัตกรรมหรือนำเทคโนโลยีมาใช้ในการผลิตสินค้าหรือบริการ (ประกาศข้อ 9)",
    3: "ผู้ดำเนินการทดสอบฯและผู้ดำเนินการประเมินความรู้ความสามารถส่งเงินค่าทดสอบเข้ากองทุนฯ (ประกาศข้อ 10)",
    9: "ดำเนินการประเมินความรู้ความสามารถและส่งเงินค่าธรรมเนียมเข้ากองทุนพัฒนาฝีมือแรงงาน (ประกาศ 10)",
    10: "ศูนย์ประเมินความรู้ความสามารถกลาง (ประกาศข้อ 11)",
    11: "กรมพัฒนาฝีมือแรงงาน (ประกาศข้อ 12)",
    12: "กรมพัฒนาฝีมือแรงงาน (ประกาศข้อ 13)",
    13: "ศูนย์ประเมินความรู้ความสามารถ ตามมาตรา 26/4 (2) (ประกาศข้อ 14)",
    14: "กรมพัฒนาฝีมือแรงงาน (ประกาศข้อ 15)",
};




export function Report56Component() {

    const currentYearTh = new Date().getFullYear() + 543;

    const [startBudgetYear, setStartBudgetYear] = useState(currentYearTh);
    const [endBudgetYear, setEndBudgetYear] = useState(currentYearTh);

    const [reportData, setReportData] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);

    const [detailData, setDetailData] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);

    /* =========================
       PDF FONT
    ========================== */
    function base64FromArrayBuffer(buf) {
        const bytes = new Uint8Array(buf);
        const chunkSize = 0x8000;
        let binary = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode.apply(
                null,
                bytes.subarray(i, i + chunkSize)
            );
        }
        return btoa(binary);
    }

    let thaiFontLoaded = false;

    async function ensureThaiFontLoaded() {
        if (thaiFontLoaded) return;

        const [regRes, boldRes] = await Promise.all([
            fetch("/fonts/Sarabun-Regular.ttf"),
            fetch("/fonts/Sarabun-Bold.ttf")
        ]);

        const [regBuf, boldBuf] = await Promise.all([
            regRes.arrayBuffer(),
            boldRes.arrayBuffer()
        ]);

        const regB64 = base64FromArrayBuffer(regBuf);
        const boldB64 = base64FromArrayBuffer(boldBuf);

        jsPDF.API.events.push([
            "addFonts",
            function () {
                this.addFileToVFS("Sarabun-Regular.ttf", regB64);
                this.addFileToVFS("Sarabun-Bold.ttf", boldB64);
                this.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");
                this.addFont("Sarabun-Bold.ttf", "Sarabun", "bold");
            }
        ]);

        new jsPDF();
        thaiFontLoaded = true;
    }

    /* =========================
       FETCH SUMMARY
    ========================== */
    async function fetchReport56() {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("startBudgetYear", startBudgetYear);
            formData.append("endBudgetYear", endBudgetYear);

            const res = await fetch("/api/SupportReports/dataReport56", {
                method: "POST",
                body: formData
            });

            const json = await res.json();
            setReportData(json.dataenum || []);
        }
        finally {
            setLoading(false);
        }
    }

    /* =========================
       FETCH YEAR OPTIONS
    ========================== */
    async function fetchYearOptions() {
        const res = await fetch("/api/Support/getyear57");
        const json = await res.json();
        setYearOptions(json.dataenum || []);
    }

    /* =========================
       FETCH DETAIL
    ========================== */
    async function fetchDetail(budgetYear) {
        try {
            setDetailLoading(true);
            setOpenModal(true);
            setDetailData([]);

            const res = await fetch(
                "/api/SupportReports/dataReportSupportNames?budgetYear=" + budgetYear
            );
            const json = await res.json();
            setDetailData(json.dataenum || []);
        }
        finally {
            setDetailLoading(false);
        }
    }


    /* =========================
       EFFECT
    ========================== */
    useEffect(() => {
        fetchReport56();
        fetchYearOptions();
    }, [startBudgetYear, endBudgetYear]);

    const budgetYears = [];

    for (let y = Number(startBudgetYear); y <= Number(endBudgetYear); y++) {
        budgetYears.push(y);
    }

    // =============================
    // หากลุ่มประกาศ (column) จากข้อมูลจริงที่ backend ส่งมา
    // เรียงตามลำดับที่ปรากฏใน detailBudgetYear (ประกาศ-major, ปี-minor)
    // เพื่อให้หัวตารางตรงกับจำนวนคอลัมน์ข้อมูลเสมอ (รวมประกาศ 12-15)
    // =============================
    const orderedTypes = [];
    (reportData[0]?.detailBudgetYear ?? []).forEach(d => {
        if (!orderedTypes.includes(d.supportTypeId)) {
            orderedTypes.push(d.supportTypeId);
        }
    });
    const announcementGroups = orderedTypes.map(
        t => TYPE_LABEL_MAP[t] ?? `ประเภท ${t}`
    );

    // นิยามคอลัมน์แบบ (ประเภท, ปี) เรียงแบบประเภท-major -> ปี-minor ให้ตรงกับหัวตาราง
    const columnDefs = [];
    orderedTypes.forEach(type => {
        budgetYears.forEach(year => {
            columnDefs.push({ type, year });
        });
    });

    // หาเซลล์ข้อมูลของ (ประเภท, ปี) จากแถวหน่วยงาน
    const findCell = (row, type, year) =>
        (row?.detailBudgetYear || []).find(
            d => d.supportTypeId === type && d.budgetYear === year
        ) || {};

    // =============================
    // รวมตาม "ประกาศ + ปี" (ตาม columnDefs)
    // =============================
    const columnTotals = columnDefs.map(({ type, year }) => {
        let supportAmount = 0, personAmount = 0, amount = 0;
        reportData.forEach(row => {
            const d = findCell(row, type, year);
            supportAmount += d?.supportAmount || 0;
            personAmount += d?.personAmount || 0;
            amount += d?.amount || 0;
        });
        return { supportAmount, personAmount, amount };
    });



    const exportExcel = () => {

        const wb = XLSX.utils.book_new();
        const wsData = [];

        const totalGroups = announcementGroups.length;
        const yearCount = budgetYears.length;

        const headerRow1 = ["ที่", "หน่วยงาน"];
        const headerRow2 = ["", ""];
        const headerRow3 = ["", ""];

        // ====== ประกาศ ======
        announcementGroups.forEach(group => {

            headerRow1.push(group);

            for (let y = 1; y < yearCount * 3; y++) {
                headerRow1.push("");
            }

            budgetYears.forEach(year => {
                headerRow2.push(`ปีงบประมาณ ${year}`, "", "");
            });

            budgetYears.forEach(() => {
                headerRow3.push("(แห่ง)", "(คน)", "(บาท)");
            });

        });

        // ====== รวม ======
        headerRow1.push("รวม");
        for (let y = 1; y < yearCount * 3; y++) {
            headerRow1.push("");
        }

        budgetYears.forEach(year => {
            headerRow2.push(`ปีงบประมาณ ${year}`, "", "");
        });

        budgetYears.forEach(() => {
            headerRow3.push("(แห่ง)", "(คน)", "(บาท)");
        });

        wsData.push(headerRow1);
        wsData.push(headerRow2);
        wsData.push(headerRow3);

        // ================= BODY =================
        reportData.forEach((row, i) => {

            const rowData = [];
            rowData.push(i + 1);
            rowData.push(row.deptName);

            row.detailBudgetYear.forEach(d => {
                rowData.push(d.supportAmount || 0);
                rowData.push(d.personAmount || 0);
                rowData.push(d.amount || 0);
            });

            // รวมรายปี
            const totalByYear = budgetYears.map(year => {
                const items = row.detailBudgetYear.filter(d => d.budgetYear === year);
                return {
                    supportAmount: items.reduce((s, x) => s + (x.supportAmount || 0), 0),
                    personAmount: items.reduce((s, x) => s + (x.personAmount || 0), 0),
                    amount: items.reduce((s, x) => s + (x.amount || 0), 0)
                };
            });

            totalByYear.forEach(t => {
                rowData.push(t.supportAmount);
                rowData.push(t.personAmount);
                rowData.push(t.amount);
            });

            wsData.push(rowData);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // ================= MERGE =================
        const merges = [];

        let colIndex = 2;

        // merge ประกาศ
        announcementGroups.forEach(() => {

            merges.push({
                s: { r: 0, c: colIndex },
                e: { r: 0, c: colIndex + (yearCount * 3) - 1 }
            });

            budgetYears.forEach(() => {

                merges.push({
                    s: { r: 1, c: colIndex },
                    e: { r: 1, c: colIndex + 2 }
                });

                colIndex += 3;
            });

        });

        // merge รวม
        merges.push({
            s: { r: 0, c: colIndex },
            e: { r: 0, c: colIndex + (yearCount * 3) - 1 }
        });

        budgetYears.forEach(() => {

            merges.push({
                s: { r: 1, c: colIndex },
                e: { r: 1, c: colIndex + 2 }
            });

            colIndex += 3;
        });

        ws["!merges"] = merges;

        XLSX.utils.book_append_sheet(wb, ws, "Report56");
        XLSX.writeFile(wb, "Report56.xlsx");
    };


    const exportPDF = async () => {

        await ensureThaiFontLoaded();

        const doc = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: "a2"
        });

        doc.setFont("Sarabun");

        const tableHead = [];

        const header1 = ["ที่", "หน่วยงาน"];
        const header2 = ["", ""];
        const header3 = ["", ""];

        announcementGroups.forEach(group => {

            header1.push(group);
            for (let y = 1; y < budgetYears.length * 3; y++) {
                header1.push("");
            }

            budgetYears.forEach(year => {
                header2.push(`ปีงบประมาณ ${year}`, "", "");
            });

            budgetYears.forEach(() => {
                header3.push("(แห่ง)", "(คน)", "(บาท)");
            });

        });

        // รวม
        header1.push("รวม");
        for (let y = 1; y < budgetYears.length * 3; y++) {
            header1.push("");
        }

        budgetYears.forEach(year => {
            header2.push(`ปีงบประมาณ ${year}`, "", "");
        });

        budgetYears.forEach(() => {
            header3.push("(แห่ง)", "(คน)", "(บาท)");
        });

        tableHead.push(header1);
        tableHead.push(header2);
        tableHead.push(header3);

        const tableBody = [];

        reportData.forEach((row, i) => {

            const rowData = [];
            rowData.push(i + 1);
            rowData.push(row.deptName);

            row.detailBudgetYear.forEach(d => {
                rowData.push(d.supportAmount || 0);
                rowData.push(d.personAmount || 0);
                rowData.push(d.amount || 0);
            });

            const totalByYear = budgetYears.map(year => {
                const items = row.detailBudgetYear.filter(d => d.budgetYear === year);
                return {
                    supportAmount: items.reduce((s, x) => s + (x.supportAmount || 0), 0),
                    personAmount: items.reduce((s, x) => s + (x.personAmount || 0), 0),
                    amount: items.reduce((s, x) => s + (x.amount || 0), 0)
                };
            });

            totalByYear.forEach(t => {
                rowData.push(t.supportAmount);
                rowData.push(t.personAmount);
                rowData.push(t.amount);
            });

            tableBody.push(rowData);
        });

        autoTable(doc, {
            head: tableHead,
            body: tableBody,
            startY: 15,
            styles: {
                font: "Sarabun",
                fontSize: 6,
                cellPadding: 1
            },
            theme: "grid"
        });

        doc.save("Report56.pdf");
    };






    return (
        <Container>
            {/* ===== FILTER ===== */}
            <Row className="mb-3 align-items-center">
                <Col md={2}><h5>ปีงบประมาณ</h5></Col>

                <Col md={3}>
                    <Input
                        type="select"
                        value={startBudgetYear}
                        disabled={loading}
                        onChange={e => setStartBudgetYear(e.target.value)}
                    >
                        {yearOptions.map(y => (
                            <option key={y.yearTh} value={y.yearTh}>
                                {y.yearTh}
                            </option>
                        ))}
                    </Input>
                </Col>

                <Col md={1} className="text-center">ถึง</Col>

                <Col md={3}>
                    <Input
                        type="select"
                        value={endBudgetYear}
                        disabled={loading}
                        onChange={e => setEndBudgetYear(e.target.value)}
                    >
                        {yearOptions
                            .filter(y => y.yearTh >= startBudgetYear)
                            .map(y => (
                                <option key={y.yearTh} value={y.yearTh}>
                                    {y.yearTh}
                                </option>
                            ))}
                    </Input>
                </Col>

                <Col md={3} className="text-end">
                    <Button
                        className="btn-export excel me-2"
                        onClick={exportExcel}
                        disabled={loading || !reportData.length}
                    >
                        Excel
                    </Button>
                    <Button
                        className="btn-export pdf"
                        onClick={exportPDF}
                        disabled={loading || !reportData.length}
                    >
                        PDF
                    </Button>
                </Col>
            </Row>


            {/* ===== TABLE ===== */}
            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" />
                    <div className="mt-2">กำลังโหลดข้อมูล...</div>
                </div>
            ) : (
                <Table
                    bordered
                    hover
                    responsive
                    className="report-table"
                    style={{
                        minWidth: "8000px",
                    }}
                >
                    <thead>
                        <tr>
                            <th rowSpan="3">ที่</th>
                            <th rowSpan="3">หน่วยงาน</th>

                            {announcementGroups.map((group, gIdx) => (
                                <th
                                    key={"group-" + gIdx}
                                    colSpan={budgetYears.length * 3}
                                    className="text-center"
                                >
                                    {group}
                                </th>
                            ))}

                            <th
                                colSpan={budgetYears.length * 3}
                                className="text-center bg-light"
                            >
                                รวม
                            </th>
                        </tr>

                        {/* ===== แถวปีงบประมาณ ===== */}
                        <tr>
                            {announcementGroups.map((group, gIdx) => (
                                budgetYears.map((year) => (
                                    <th
                                        key={"year-" + gIdx + "-" + year}
                                        colSpan="3"
                                        className="text-center"
                                    >
                                        ปีงบประมาณ {year}
                                    </th>
                                ))
                            ))}

                            {budgetYears.map((year) => (
                                <th
                                    key={"total-" + year}
                                    colSpan="3"
                                    className="text-center bg-light"
                                >
                                    ปีงบประมาณ {year}
                                </th>
                            ))}
                        </tr>

                        {/* ===== แถวหน่วย ===== */}
                        <tr>
                            {announcementGroups.map((group, gIdx) => (
                                budgetYears.map((year) => (
                                    <React.Fragment key={"unit-" + gIdx + "-" + year}>
                                        <th className="text-center">(แห่ง)</th>
                                        <th className="text-center">(คน)</th>
                                        <th className="text-center">(บาท)</th>
                                    </React.Fragment>
                                ))
                            ))}

                            {budgetYears.map((year) => (
                                <React.Fragment key={"total-unit-" + year}>
                                    <th className="text-center bg-light">(แห่ง)</th>
                                    <th className="text-center bg-light">(คน)</th>
                                    <th className="text-center bg-light">(บาท)</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {reportData.map((row, i) => {

                            // สร้าง array รวมแยกตามปี
                            const totalByYear = budgetYears.map(year => {
                                const items = row.detailBudgetYear.filter(d => d.budgetYear === year);

                                return {
                                    supportAmount: items.reduce((sum, x) => sum + (x.supportAmount || 0), 0),
                                    personAmount: items.reduce((sum, x) => sum + (x.personAmount || 0), 0),
                                    amount: items.reduce((sum, x) => sum + (x.amount || 0), 0)
                                };
                            });

                            return (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td className="text-start">{row.deptName}</td>

                                    {/* ข้อมูลแต่ละประกาศ/ปี (lookup ตาม columnDefs ให้ตรงกับหัวตาราง) */}
                                    {columnDefs.map(({ type, year }, j) => {
                                        const data = findCell(row, type, year);
                                        return (
                                            <React.Fragment key={"cell-" + j}>
                                                <td className='text-end'>{NumberWithCommmas2(data.supportAmount || 0)}</td>
                                                <td className='text-end'>{NumberWithCommmas2(data.personAmount || 0)}</td>
                                                <td className='text-end'>{NumberWithCommmas2(data.amount || 0)}</td>
                                            </React.Fragment>
                                        );
                                    })}

                                    {/* คอลัมน์รวม */}
                                    {totalByYear.map((data, idx) => (
                                        <React.Fragment key={"total-" + idx}>
                                            <td className='text-end fw-bold bg-light'>
                                                {NumberWithCommmas2(data.supportAmount)}
                                            </td>
                                            <td className='text-end fw-bold bg-light'>
                                                {NumberWithCommmas2(data.personAmount)}
                                            </td>
                                            <td className='text-end fw-bold bg-light'>
                                                {NumberWithCommmas2(data.amount)}
                                            </td>
                                        </React.Fragment>
                                    ))}

                                </tr>
                            );
                        })}
                    </tbody>

                    <tfoot>
                        <tr className="table-summary">
                            <td colSpan="2" className="text-center fw-bold">
                                รวม
                            </td>

                            {columnTotals.map((col, index) => (
                                <React.Fragment key={index}>
                                    <td className="text-end fw-bold">
                                        {NumberWithCommmas2(col.supportAmount)}
                                    </td>
                                    <td className="text-end fw-bold">
                                        {NumberWithCommmas2(col.personAmount)}
                                    </td>
                                    <td className="text-end fw-bold">
                                        {NumberWithCommmas2(col.amount)}
                                    </td>
                                </React.Fragment>
                            ))}
                        </tr>
                    </tfoot>



                </Table>
            )}



        </Container>


    )
}